import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
export const queryServiceByFormId = async _ref => {
  let {
    httpClient,
    errorHandler,
    formId
  } = _ref;
  try {
    var _response$data$servic;
    const response = await errorHandler.withErrorHandler(() => httpClient.request(queryServices({
      query: {
        filter: {
          'form.id': {
            $in: [formId]
          }
        }
      }
    })), {
      errorCodesMap: {}
    });
    return (_response$data$servic = response.data.services) == null ? void 0 : _response$data$servic[0];
  } catch (e) {
    const resolvedError = errorHandler.getResolvedError(e);
    console.error(resolvedError);
    return undefined;
  }
};
//# sourceMappingURL=query-service-by-form-id.js.map